import serviceRest from "./serviceRest";

const sessionUser = (module) => {
    return serviceRest.post('/react/user/session', {"module": module});
};

const SessionService = {
    sessionUser
};

export default SessionService;
